import { useRef, useState } from "react";
import { Play, Pause, Music } from "lucide-react";

export default function AudioPlayer() {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [hint, setHint] = useState(true);

  const toggle = async () => {
    setHint(false);
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) {
      audio.pause();
      setPlaying(false);
      return;
    }
    try {
      audio.volume = 0.35;
      await audio.play();
      setPlaying(true);
    } catch {
      setPlaying(false);
    }
  };

  return (
    <>
      <audio ref={audioRef} src="/assets/backsound.mp3" loop preload="none" data-testid="background-audio" />
      <div className="fixed bottom-5 left-5 z-[60] flex items-center gap-2.5" data-testid="music-player">
        {hint && (
          <button
            onClick={toggle}
            data-testid="music-hint"
            className="animate-pulse rounded-full border border-brand/20 bg-white/95 px-4 py-2 text-xs font-semibold text-brand shadow-lg backdrop-blur transition-colors hover:bg-brand-mist"
          >
            Putar musik latar
          </button>
        )}
        <button
          onClick={toggle}
          aria-label={playing ? "Jeda musik latar" : "Putar musik latar"}
          data-testid="music-toggle-button"
          className={`relative flex h-12 w-12 items-center justify-center rounded-full border shadow-[0_8px_24px_rgb(0,86,179,0.25)] backdrop-blur transition-all duration-200 active:scale-95 ${
            playing ? "border-brand bg-brand text-white" : "border-brand/25 bg-white/95 text-brand hover:bg-brand-mist"
          }`}
        >
          {playing ? (
            <>
              <span className="absolute inset-0 -z-10 animate-pulse-ring rounded-full bg-brand" aria-hidden="true" />
              <span className="flex items-end gap-[3px]" aria-hidden="true">
                <span className="music-bar inline-block h-3.5 w-[3px] rounded-full bg-white" style={{ animationDelay: "0s" }} />
                <span className="music-bar inline-block h-3.5 w-[3px] rounded-full bg-white" style={{ animationDelay: "0.25s" }} />
                <span className="music-bar inline-block h-3.5 w-[3px] rounded-full bg-white" style={{ animationDelay: "0.5s" }} />
              </span>
              <Pause className="sr-only" />
            </>
          ) : (
            <Play className="ml-0.5 h-5 w-5" />
          )}
        </button>
        {playing && (
          <span className="hidden items-center gap-1.5 rounded-full bg-white/90 px-3 py-1.5 text-[11px] font-medium text-slate-500 shadow backdrop-blur sm:flex" data-testid="music-now-playing">
            <Music className="h-3 w-3 text-brand" /> Musik latar
          </span>
        )}
      </div>
    </>
  );
}
